import { axiosInstance } from '@/shared/api/axios';
import {
  ExecuteSingleRegistrySearchRequestType,
  ExecuteSingleRegistrySearchResponseType,
} from '@/shared/types/api/api.checkResultRegistry';

export const executeSingleRegistrySearch = async (
  params: ExecuteSingleRegistrySearchRequestType,
): Promise<ExecuteSingleRegistrySearchResponseType> => {
  const { data } = await axiosInstance.post<ExecuteSingleRegistrySearchResponseType>(
    `/check-results/registry/execute-single`,
    params,
  );

  return data;
};
